import React from 'react';
import { AppBar, Toolbar, Typography, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const ChatHeader = ({ colors, onClose }) => {

  return (
    <AppBar position="static" sx={{ backgroundColor: colors.primary.backgroundColor, borderTopLeftRadius:20,borderTopRightRadius:20}}>
      <Toolbar variant="dense">
        <Typography variant="h6" sx={{ flexGrow: 1, color: colors.primary.color }}>
          Bs4 AI Chat
        </Typography>
        <IconButton onClick={onClose} sx={{ color: colors.primary.color }}>
          <CloseIcon />
        </IconButton>
      </Toolbar>
    </AppBar>
  );
};

export default ChatHeader;